import { noop } from 'lodash';

import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';
import { VisitUpdatePhysicalExaminationCommand } from '@dreryk/egabinet-visit-frontend-api';

import { TextEditorValue } from '@dreryk/react-text-editor';
import { FieldController, TranslatableText } from '@dreryk/react-common';
import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { Choice } from '@dreryk/watermelon';

import { subjectiveAssessmentTranslationKeys } from '../../../translations';
import { VisitFormTextEditor } from '../shared/VisitFormTextEditor';

type SubjectiveAssessmentTextEditorProps = {
   readonly controller: FieldController<TextEditorValue | null>;
   readonly practitionerId: PractitionerId;
   readonly visitId: number;
   readonly label?: TranslatableText;
};

export const SubjectiveAssessmentTextEditor = (props: SubjectiveAssessmentTextEditorProps): JSX.Element => {
   const { executeAsync: updateSubjectiveAssessment } = useCqrsCommand<void, { value: TextEditorValue | null }>(
      ({ value }) => {
         const command = new VisitUpdatePhysicalExaminationCommand();
         command.id = props.visitId;
         command.physicalExamination = Choice.withUseDefaultIfNull(value?.getFormattedValue() ?? null);
         return command;
      },
      {
         onUnexpectedError: noop,
      }
   );

   return (
      <VisitFormTextEditor
         testId={'subjectiveAssessment'}
         label={props.label}
         placeholder={subjectiveAssessmentTranslationKeys.placeholder}
         modalLabel={subjectiveAssessmentTranslationKeys.label}
         controller={props.controller}
         practitionerId={props.practitionerId}
         onAutoSave={updateSubjectiveAssessment}
      />
   );
};
